import React from 'react'
import { ExperienceSellableDetailsFragment } from '#src/generated/graphql'
import styles from './styles.css'

interface CharterAmenitiesProps {
  sellable: ExperienceSellableDetailsFragment
}

const CharterAmenities: React.SFC<CharterAmenitiesProps> = ({ sellable }) => {
  const amenities = sellable.charterAmenities

  let amenitiesSet: string[] = []
  if (amenities && amenities.formatted) {
    amenitiesSet = amenities.formatted.displayHtml.split(', ')
  } else {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.accessories}>
        {amenitiesSet.map((amenity, idx) => (
          <div className={styles.accessory} key={idx}>
            <span className={styles.bullet}>•</span> <span className={styles.label}>{amenity}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CharterAmenities
